<template>
  <div>
    <div class="trigger" @click="onClickTrigger">
      <i class="fas fa-chevron-right"></i>
    </div>

    <side-panel v-if="panelOpen" :onClose="onClose">
      <template>
        <load-content :loading="isBusy">
          <div v-if="grouping" id="side-panel-content">
            <h3>{{grouping.group_name}}</h3>
            <div class="form form--sidepanel form-wrapper" id="form-grouping-actions">
              <div v-if="model.length > 0" class="tags">
                <div class="row" v-for="(tag, index) in model" :key="tag.id">

                  <div class="flex-2">
                    <div class="form-group">
                      <label for="">{{$t('relations.groups.labels.category')}}</label>
                      <input-select
                        name="associated_tag_category_id"
                        ref="associated_tag_category_id"
                        :selectedValue="tag.category_id"
                        :allowEmpty="false"
                        :preselectFirst="true"
                        :options="categoryOptions"
                        :onChange="(value) => onChangeCategory(index, value)"
                        style="flex: 1; width: auto"
                      />
                    </div>
                    <div class="form-group">
                      <label for="">{{$t('relations.groups.labels.tag')}}</label>
                      <input-select
                        name="associated_tag_id"
                        ref="associated_tag_id"
                        :selectedValue="tag.id"
                        :allowEmpty="false"
                        :options="getTagOptions(tag.category_id)"
                        :onChange="(value) => onChange(index, value)"
                      />
                    </div>
                  </div>

                  <div class="remove text-danger mt15 cursor-pointer" @click="() => onRemoveTag(index)" v-tooltip="$t('form.button.remove')">
                    <i class="fas fa-times"/>
                  </div>
                </div>
              </div>
              <div v-else>{{$t('relations.groups.empty')}}</div>

              <div class="btn-container">
                <button class="btn btn-default btn-sm" :class="{ disabled: !hasOptionsAvailable }" @click="addTag">
                  <i class="fas fa-plus"></i> {{$t('relations.groups.actions.add')}}
                </button>
                <button class="btn btn-carma btn-sm" @click="saveChanges">
                  <i class="fas fa-check"></i> {{$t('relations.groups.actions.save')}}
                </button>
              </div>

            </div>
          </div>
        </load-content>
      </template>
    </side-panel>

  </div>
</template>

<script>
import SidePanel from '../side-panel';
import LoadContent from '../load-content';
import InputSelect from '../form-components/input-select';

export default {
  props: {
    isBusy: Boolean,
    categories: Array,
    tags: Array,
    grouping: Object,
    onSave: Function
  },

  computed: {
    categoryOptions () {
      return this.categories.map(c => {
        const tagOptions = this.getTagOptions(c.id);
        const disabled = tagOptions.filter(option => !option.$isDisabled).length === 0;
        return { value: c.id, label: c.name, $isDisabled: disabled }
      });
    },

    hasOptionsAvailable () {
      return this.categoryOptions.filter(option => !option.$isDisabled).length > 0;
    }
  },

  data: function() {
    return {
      panelOpen: false,
      model: []
    }
  },

  methods: {
    getTagOptions: function (categoryId) {
      return this.categories.find(c => c.id === categoryId)?.tags.map(t => ({ value: t.id, label: t.name, $isDisabled: this.model.findIndex(m => m.category_id === t.cat_id && m.id === t.id) > -1 }));
    },

    onClickTrigger: function() {
      this.panelOpen = true;
      this.model = [...this.grouping.grouping_tags];
    },

    onClose: function() {
      this.panelOpen = false;
    },

    addTag: function() {
      if (this.hasOptionsAvailable) {
        const category = this.categoryOptions.find(option => !option.$isDisabled);
        const tagOptions = this.getTagOptions(category.value);
        const tag = tagOptions.find(option => !option.$isDisabled);
        this.model.push({
          id: tag.value,
          name: tag.label,
          category_id: category.value
        });
      }
    },

    onRemoveTag: function(index) {
      const data = [...this.model];
      data.splice(index, 1);
      this.model = data;
    },

    saveChanges: function() {
      this.$emit('save', { ...this.grouping, grouping_tags: this.model });
      this.panelOpen = false;
    },

    onChangeCategory: function(index, value) {
      const tagOptions = this.getTagOptions(value);
      const tag = tagOptions.find(t => !t.$isDisabled);

      const data = [...this.model];
      const dt = data[index];
      dt.category_id = value;
      dt.id = tag.value;
      dt.name = tag.label;

      this.model = data;
    },

    onChange: function(index, value) {
      const data = [...this.model];
      const dt = data[index];
      dt.id = value;
      this.model = data;
    }
  },

  components: {
    SidePanel,
    LoadContent,
    InputSelect
  }
}
</script>

<style lang="scss" scoped>
  .trigger {
    cursor: pointer;
    padding: 5px;
  }

  #side-panel-content {

    .row {
      display: flex;
      align-items: center;

      .flex-2 {
        display: flex;
        align-items: flex-start;
        flex: 1 1 auto;
        margin: 0 -10px;

        .form-group {
          flex: 0 0 50%;
          padding: 0 10px;
        }
      }

      .remove {
        padding: 5px;
        margin-left: 50px;
      }
    }
  }

  #form-grouping-actions {
    :deep(.input-select) {
      width: auto !important;
    }

    :deep(.multiselect__tags) {
      padding-right: 30px;
    }
  }
</style>